/*eslint no-magic-numbers: ["error", { "ignore": [0,1,2] }]*/
/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import FilterIcon from 'assets/icons/filter-icon'
import ReportsHeaderTabs from '../Reports/components/ReportsTab'
import { useParams } from 'react-router-dom'

import Button from 'components/Button'
import FiltersModal from 'features/filtersModal'

import {
  NewReportWrapper,
  NewReportSubWrapper,
  CreateReportsButtons,
  NewReportTitle,
  NewReportSubTitle,
  ReportsWrapper,
  RightButtons,
  OverviewWrapper,
  OverviewTitle,
  OverviewBoxes,
  BoxWrapper,
  Divider,
  ValueContainer,
  StyledRightCorner,
  StyleIcon,
  BoxHalfSide,
  ReportTableWrapper,
  ReportTableTitle,
  Dash,
  ReportsTableWrapper,
  Circle,
  InnerCircle,
  StyleArrow,
  ReportsPaginationWrapper,
  ReportLoadingScreen,
  ReportLoadingScreenBanner,
  ReportLoadingScreenBannerRunReportIconWrapper,
  ReportLoadingScreenBannerTitle,
  ReportLoadingScreenBannerMinorIconWrapper
} from './style'

import Spinner from '../../components/Spinner'
import SitesReportTab from './components/SitesReportTab'
import SpeciesReportsTab from './components/SpeciesReportsTab'
import MonitoringSitesTab from './components/MonitoringReportTab'
import EcosystemReportsTab from './components/EcosystemReportsTab'
import EcologicalIntegrityReportsTab from './components/EcologicalIntegrityReportsTab'
import IrreplaceabilityReportsTab from './components/IrreplaceabilityReportsTab'
import HabitatsReportsTab from './components/HabitatsReportsTab'
import PressuresReportsTab from './components/PressuresReportsTab'

const defaultFilters = {
  siteFilters: {
    region: [],
    country: [],
    system: [],
    threats: [],
    assessmentStatus: [],
    kbaStatus: [],
    kbaClassification: [],
    kbaCriterias: [],
    dateOfMostRecentAssessment: [],
    url: ''
  },
  speciesFilters: {
    speciesList: [],
    classList: [],
    selectedSpecieOptions: [],
    url: ''
  },
  ecosystemFilters: {
    ecosystemList: [],
    ecosystemRedListCategory: [],
    url: ''
  },
  ecologicalFilters: {
    ecoregionList: [],
    url: ''
  },
  showReports: false
}

export const getUrlForAllFilters = (filters) => {
  let url = []
  if (filters.siteFilters.url !== '') {
    url.push(filters.siteFilters.url)
  }
  if (filters.speciesFilters.url !== '') {
    url.push(filters.speciesFilters.url)
  }
  if (filters.monitoringFilters?.url) { 
    url.push(filters.monitoringFilters.url)
  }
  if (filters.ecosystemFilters.url !== '') {
    url.push(filters.ecosystemFilters.url)
  }
  if (filters.ecologicalFilters.url !== '') {
    url.push(filters.ecologicalFilters.url)
  }

  return url.join('&')
}

export const getFiltersCount = ({ ...filters }) => {
  const siteFilters = Object.values({ ...filters.siteFilters }).filter((item) => item.length > 0 && typeof item !== 'string')
  const speciesFilters = Object.values({ ...filters.speciesFilters }).filter((item) => item.length > 0 && typeof item !== 'string').length === 0 ? 0 : 1
  const ecosystemFilters = Object.values({ ...filters.ecosystemFilters }).filter((item) => item.length > 0 && typeof item !== 'string')
  const ecologicalFilters = Object.values({ ...filters.ecologicalFilters }).filter((item) => item.length > 0 && typeof item !== 'string')
  const monitoringFilters = Object.values({ ...filters.monitoringFilters }).filter((item) => item.length > 0 && typeof item !== 'string')

  return siteFilters.length + ecosystemFilters.length + ecologicalFilters.length + speciesFilters + monitoringFilters.length
}

const Reports = () => {
  const params = useParams()
  const [filters, setFilters] = useState(JSON.parse(localStorage.getItem('reportsFilters')) || defaultFilters)
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
  const [loadingScreenMessage, setLoadingScreenMessage] = useState('runningReport')
  const [activeTab, setActiveTab] = useState(params.title ? params.title : 'siteDetails')
  const [filterCount, setFilterCount] = useState(getFiltersCount(JSON.parse(localStorage.getItem('reportsFilters')) || defaultFilters))
  const [isSitesLoading, setIsSiteLoading] = useState(false)
  const [isSpeciesLoading, setIsSpeciesLoading] = useState(false)
  const [isRunReportTriggered, setIsRunReportTriggered] = useState(false)
  const [isMonitoringSitesLoading, setIsMonitoringSitesLoading] = useState(false)
  const [isEcosystemsLoading, setIsEcosystemsLoading] = useState(false)
  const [isEcologicalIntegrityLoading, setIsEcologicalIntegrityLoading] = useState(false)
  const [isIrreplaceabilityLoading, setIsIrreplaceabilityLoading] = useState(false)
  const [isHabitatsLoading, setIsHabitatsLoading] = useState(false)
  const [isPressuresLoading, setIsPressuresLoading] = useState(false)


  const runReports = () => {
    setFilters({ ...filters, showReports: true })
    setIsRunReportTriggered((s) => {
      return !s
    })
    localStorage.setItem('reportsFilters', JSON.stringify({ ...filters, showReports: true }))
  }

  const toggleModal = () => {
    setIsFilterModalOpen((state) => {
      return !state
    })
  }

  function changeActiveTab(e) {
    if (e.target.id === '') {
      return
    }
    setActiveTab(e.target.id)
  }

  useEffect(() => {
    if (!JSON.parse(localStorage.getItem('reportsFilters'))) {
      localStorage.setItem('reportsFilters', JSON.stringify(defaultFilters))
      setFilters(defaultFilters)
    }
  }, [])

  return (
    <>
      {(isSpeciesLoading || isSitesLoading || isMonitoringSitesLoading || isEcosystemsLoading || isEcologicalIntegrityLoading || isIrreplaceabilityLoading || isHabitatsLoading || isPressuresLoading) && (
        <ReportLoadingScreen>
          <ReportLoadingScreenBanner>
            {loadingScreenMessage === 'buildingReport' ? (
              <>
                <ReportLoadingScreenBannerRunReportIconWrapper>
                  <Spinner size='24px' secondaryColor={true} />
                </ReportLoadingScreenBannerRunReportIconWrapper>
                <ReportLoadingScreenBannerTitle>
                  <FormattedMessage id='reportLoadingScreenTitle' />
                </ReportLoadingScreenBannerTitle>
                <FormattedMessage id={loadingScreenMessage} />
              </>
            ) : (
              <>
                <ReportLoadingScreenBannerMinorIconWrapper>
                  <Spinner size='24px' />
                </ReportLoadingScreenBannerMinorIconWrapper>
                <FormattedMessage id={loadingScreenMessage} />
              </>
            )}
          </ReportLoadingScreenBanner>
        </ReportLoadingScreen>
      )}
      {!filters.showReports ? (
        <>
          <NewReportWrapper>
            <NewReportSubWrapper>
              <NewReportTitle>
                <FormattedMessage id='newReportTitle' />
              </NewReportTitle>
              <NewReportSubTitle>
                <FormattedMessage id='newReportSubTitle' />
              </NewReportSubTitle>
              <CreateReportsButtons>
                <Button
                  dataTest="filter-pannel"
                  withIcon={true}
                  marginTop="32px"
                  height="40px"
                  type="primary"
                  onClick={toggleModal}
                >
                  <FilterIcon />
                  <FormattedMessage id="filterPannel" />
                </Button>
              </CreateReportsButtons>
            </NewReportSubWrapper>
          </NewReportWrapper>
        </>
      ) : (
        <>
          {!params.title && (
            <ReportsWrapper>
              <ReportsHeaderTabs changeTab={changeActiveTab} active={activeTab} />
              <RightButtons>
                {/*<Button dataTest='download-all' withIcon={true} height='40px' marginTop='0px' type='secondary'>*/}
                {/*  <DownloadAll />*/}
                {/*  <FormattedMessage id='downloadAll' />*/}
                {/*</Button>*/}
                <div style={{ position: 'relative' }}>
                  {activeTab !== 'monitoringSites' && filterCount !== 0 && <StyledRightCorner>{filterCount}</StyledRightCorner>}
                  {activeTab !== 'monitoringSites' && (
                    <Button
                      dataTest="filters"
                      withIcon={true}
                      height="40px"
                      marginTop="0px"
                      type="primary"
                      onClick={toggleModal}
                    >
                      <FilterIcon />
                      <FormattedMessage id="filters" />
                    </Button>
                  )}
                </div>
              </RightButtons>
            </ReportsWrapper>
          )}

          {/*<OverviewWrapper>*/}
          {/*  <OverviewTitle>*/}
          {/*    <FormattedMessage id='overview' />*/}
          {/*  </OverviewTitle>*/}
          {/*  <OverviewBoxes>*/}
          {/*    <BoxWrapper>*/}
          {/*      <BoxHalfSide>*/}
          {/*        <StyleIcon>*/}
          {/*          <Circle background='rgba(10, 161, 244, 0.1)'>*/}
          {/*            <InnerCircle background='#0AA1F4' />*/}
          {/*          </Circle>*/}
          {/*        </StyleIcon>*/}
          {/*        <div style={{ width: '110px' }}>*/}
          {/*          <FormattedMessage id='numberOfKba' />*/}
          {/*        </div>*/}
          {/*      </BoxHalfSide>*/}
          {/*      <BoxHalfSide>*/}
          {/*        <StyleArrow>*/}
          {/*          <LeftArrow />*/}
          {/*        </StyleArrow>*/}
          {/*        <ValueContainer>*/}
          {/*          {siteDetailsPagination.pagination.totalNumber}*/}
          {/*        </ValueContainer>*/}
          {/*      </BoxHalfSide>*/}
          {/*    </BoxWrapper>*/}
          {/*    <Divider />*/}
          {/*    <BoxWrapper>*/}
          {/*      <BoxHalfSide>*/}
          {/*        <StyleIcon>*/}
          {/*          <Circle background='rgba(146, 191, 0, 0.15)'>*/}
          {/*            <InnerCircle background='#92BF00' />*/}
          {/*          </Circle>*/}
          {/*        </StyleIcon>*/}
          {/*        <div style={{ width: '104px' }}>*/}
          {/*          <FormattedMessage id='numberOfRecords' />*/}
          {/*        </div>*/}
          {/*      </BoxHalfSide>*/}
          {/*      <BoxHalfSide>*/}
          {/*        <StyleArrow>*/}
          {/*          <LeftArrow />*/}
          {/*        </StyleArrow>*/}
          {/*        <ValueContainer>*/}
          {/*          {speciePagination.pagination.totalNumber}*/}
          {/*        </ValueContainer>*/}
          {/*      </BoxHalfSide>*/}
          {/*    </BoxWrapper>*/}
          {/*    /!*<Divider />*!/*/}
          {/*    /!*<BoxWrapper>*!/*/}
          {/*    /!*  <BoxHalfSide>*!/*/}
          {/*    /!*    <StyleIcon>*!/*/}
          {/*    /!*      <Circle background='rgba(255, 153, 0, 0.15)'>*!/*/}
          {/*    /!*        <InnerCircle background='#FF9900' />*!/*/}
          {/*    /!*      </Circle>*!/*/}
          {/*    /!*    </StyleIcon>*!/*/}
          {/*    /!*    <FormattedMessage id='ecosystems' />*!/*/}
          {/*    /!*  </BoxHalfSide>*!/*/}
          {/*    /!*  <BoxHalfSide>*!/*/}
          {/*    /!*    <StyleArrow>*!/*/}
          {/*    /!*      <LeftArrow />*!/*/}
          {/*    /!*    </StyleArrow>*!/*/}
          {/*    /!*    <ValueContainer>*!/*/}
          {/*    /!*      {'N/A'}*!/*/}
          {/*    /!*    </ValueContainer>*!/*/}
          {/*    /!*  </BoxHalfSide>*!/*/}
          {/*    /!*</BoxWrapper>*!/*/}
          {/*  </OverviewBoxes>*/}
          {/*</OverviewWrapper>*/}
          {activeTab === 'siteDetails' && (<SitesReportTab
              filters={filters}
              setFilters={setFilters}
              setLoadingScreenMessage={setLoadingScreenMessage}
              isSitesLoading={isSitesLoading}
              setIsSiteLoading={setIsSiteLoading}
              isRunReportTriggered={isRunReportTriggered}
              
            />
          )}
          {activeTab === 'speciesAtSite' && (
            <SpeciesReportsTab
              filters={filters}
              setFilters={setFilters}
              setLoadingScreenMessage={setLoadingScreenMessage}
              isSpeciesLoading={isSpeciesLoading}
              setIsSpeciesLoading={setIsSpeciesLoading}
              isRunReportTriggered={isRunReportTriggered}
            />
          )}
          {activeTab === 'ecosystemsAtSite' && (
            <EcosystemReportsTab
              filters={filters}
              setFilters={setFilters}
              setLoadingScreenMessage={setLoadingScreenMessage}
              isEcosystemsLoading={isEcosystemsLoading}
              setIsEcosystemsLoading={setIsEcosystemsLoading}
              isRunReportTriggered={isRunReportTriggered}
            />
          )}
          {activeTab === 'ecologicalIntegrity' && (
            <EcologicalIntegrityReportsTab
              filters={filters}
              setFilters={setFilters}
              setLoadingScreenMessage={setLoadingScreenMessage}
              isEcologicalIntegrityLoading={isEcologicalIntegrityLoading}
              setIsEcologicalIntegrityLoading={setIsEcologicalIntegrityLoading}
              isRunReportTriggered={isRunReportTriggered}
            />
          )}
          {activeTab === 'irreplaceability' && (
            <IrreplaceabilityReportsTab
              filters={filters}
              setFilters={setFilters}
              setLoadingScreenMessage={setLoadingScreenMessage}
              isIrreplaceabilityLoading={isIrreplaceabilityLoading}
              setIsIrreplaceabilityLoading={setIsIrreplaceabilityLoading}
              isRunReportTriggered={isRunReportTriggered}
            />
          )}
          {activeTab === 'habitats' && (
            <HabitatsReportsTab
              filters={filters}
              setFilters={setFilters}
              setLoadingScreenMessage={setLoadingScreenMessage}
              isHabitatsLoading={isHabitatsLoading}
              setIsHabitatsLoading={setIsHabitatsLoading}
              isRunReportTriggered={isRunReportTriggered}
            />
          )}
          {activeTab === 'pressures' && (
            <PressuresReportsTab
              filters={filters}
              setFilters={setFilters}
              setLoadingScreenMessage={setLoadingScreenMessage}
              isPressuresLoading={isPressuresLoading}
              setIsPressuresLoading={setIsPressuresLoading}
              isRunReportTriggered={isRunReportTriggered}
            />
          )}
          {activeTab === 'monitoringSites' && (
            <MonitoringSitesTab
              filters={filters}
              setFilters={setFilters}
              setLoadingScreenMessage={setLoadingScreenMessage}
              isMonitoringSitesLoading={isMonitoringSitesLoading}
              setIsMonitoringSitesLoading={setIsMonitoringSitesLoading}
              isRunReportTriggered={isRunReportTriggered}
            />
          )}
        </>
      )}
      <FiltersModal
        isOpen={isFilterModalOpen}
        label="createReport"
        toggleModal={toggleModal}
        setFilterCount={setFilterCount}
        filterCount={filterCount}
        filters={filters}
        setFilters={setFilters}
        runReports={runReports}
        defaultFilters={defaultFilters}
      />
    </>
  )
}

export default Reports
